/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseEvidencesInnerErrors } from './get-payment-request-detail200-response-evidences-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseEvidencesInnerFile } from './get-payment-request-detail200-response-evidences-inner-file';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseEvidencesInnerInvoiceIssuer } from './get-payment-request-detail200-response-evidences-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseEvidencesInnerUpdatedBy } from './get-payment-request-detail200-response-evidences-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseEvidencesInnerUploadedBy } from './get-payment-request-detail200-response-evidences-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseEvidencesInnerWarnings } from './get-payment-request-detail200-response-evidences-inner-warnings';

/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseEvidencesInner
 */
export interface GetPaymentRequestDetail200ResponseEvidencesInner {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'paymentType': GetPaymentRequestDetail200ResponseEvidencesInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'electronicMethod': GetPaymentRequestDetail200ResponseEvidencesInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'documentSize': GetPaymentRequestDetail200ResponseEvidencesInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'legalValidity': GetPaymentRequestDetail200ResponseEvidencesInnerLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseEvidencesInnerFile}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'file': GetPaymentRequestDetail200ResponseEvidencesInnerFile;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseEvidencesInnerInvoiceIssuer}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'invoiceIssuer': GetPaymentRequestDetail200ResponseEvidencesInnerInvoiceIssuer | null;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseEvidencesInnerErrors}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'errors': GetPaymentRequestDetail200ResponseEvidencesInnerErrors;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseEvidencesInnerWarnings}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'warnings': GetPaymentRequestDetail200ResponseEvidencesInnerWarnings;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseEvidencesInnerUpdatedBy}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'updatedBy': GetPaymentRequestDetail200ResponseEvidencesInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseEvidencesInnerUploadedBy}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'uploadedBy': GetPaymentRequestDetail200ResponseEvidencesInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'needsMigration'?: boolean;
}

export const GetPaymentRequestDetail200ResponseEvidencesInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerPaymentTypeEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerPaymentTypeEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerPaymentTypeEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerElectronicMethodEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerElectronicMethodEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerElectronicMethodEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerDocumentSizeEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerDocumentSizeEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerDocumentSizeEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerLegalValidityEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerLegalValidityEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerLegalValidityEnum];


